import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories, featuredComics } from '@/mocks/comics';

export default function CategoryGrid() {
  const [activeCategory, setActiveCategory] = useState<string>('全部');

  const allCategories = [{ name: '全部', icon: 'ri-apps-line' }, ...categories];

  const filteredComics = activeCategory === '全部'
    ? featuredComics
    : featuredComics.filter((c) => c.category === activeCategory);

  return (
    <section className="py-14 md:py-20 bg-secondary-900">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-center gap-4 mb-10">
          <button className="self-start inline-flex items-center gap-2 px-4 py-2 rounded-full border border-foreground-400/40 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer">
            <i className="ri-filter-line"></i>
            筛选
          </button>
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-background-50 whitespace-nowrap">
            分类浏览
          </h2>
        </div>

        <div className="flex flex-wrap gap-2 mb-10">
          {allCategories.map((cat) => (
            <button
              key={cat.name}
              onClick={() => setActiveCategory(cat.name)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeCategory === cat.name
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-foreground-800/40 text-foreground-300 hover:bg-foreground-700/40'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {filteredComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 bg-background-100">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - ${comic.category} | 韩漫漫画网`}
                  className="w-full aspect-[5/7] object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-bold whitespace-nowrap">
                  {comic.rating}分
                </div>
              </div>
              <h3 className="text-sm font-semibold text-background-50 group-hover:text-primary-400 transition-colors duration-200 line-clamp-1 whitespace-nowrap">
                {comic.title}
              </h3>
              <div className="flex items-center justify-between mt-1">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{comic.chapters}话</span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{comic.status}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}